export default __webpack_public_path__ + "static/media/bacardi.83232bd8.png";